import React from 'react';
import { useLazyLoadQuery } from 'react-relay/hooks';

import { graphql } from 'babel-plugin-relay/macro';

import FiltersContentLoader from '../FiltersContentLoader';
import FiltersSenderList from './FiltersSenderList';

import {
  FiltersSenderDataEmbedQuery,
  FiltersSenderDataEmbedQueryVariables,
} from './__generated__/FiltersSenderDataEmbedQuery.graphql';

interface FiltersSenderDataProps {
  variables: FiltersSenderDataEmbedQueryVariables;
  type: string;
}

const FiltersSenderData: React.FC<FiltersSenderDataProps> = ({ variables, type }) => {
  const data = useLazyLoadQuery<FiltersSenderDataEmbedQuery>(
    graphql`
      query FiltersSenderDataEmbedQuery($filter: FilterFindManyUserInput) {
        ...FiltersSenderList_EmbedQuery
      }
    `,
    variables,
    { fetchPolicy: 'store-or-network' },
  );

  return <FiltersSenderList type={type} fragmentRef={data} />;
};

export default (props: any) => (
  <React.Suspense fallback={<FiltersContentLoader />}>
    <FiltersSenderData {...props} />
  </React.Suspense>
);
